import React from "react";
import { ChannelCard } from "./channel-card";

function Channels() {
  return (
    <div className="">
      <h3 className="text-lg font-medium text-center xl:text-3xl md:text-xl">
        Explore our channels
      </h3>
      <div className="bg-red-600 h-1  rounded-full w-[180px] md:w-[200px] lg:w-[300px] mx-auto my-2"></div>

      <div className="grid grid-cols-1 gap-8 mt-10 sm:grid-cols-2 lg:grid-cols-4">
        <ChannelCard
          image={require("../assets/channels/arena.png")}
          title="Arena"
          url="/channels/arena"
        />

        <ChannelCard
          image={require("../assets/channels/nexa.jpg")}
          title="Nexa"
          url="/channels/nexa"
        />

        <ChannelCard
          image={require("../assets/channels/goods.png")}
          title="Commercial"
          url="/channels/commercial"
        />

        <ChannelCard
          image={require("../assets/channels/truevalue.png")}
          title="Truevalue"
          url="/truevalue"
        />
      </div>
    </div>
  );
}

export default Channels;
